import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/leads/leadsReportActions'
import * as api from '../../../api/reports/leads/leadsReport'

function* leadsReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({ type: constants.LEADS_REPORT_GET_ORGANIZATION_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEADS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* leadsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.LEADS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEADS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchleadsReportGetOrganizationList() {
  yield takeLatest(
    constants.LEADS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    leadsReportGetOrganizationList
  )
}

function* watchleadsReportGetFullReport() {
  yield takeLatest(constants.LEADS_REPORT_GET_FULL_REPORT.ACTION, leadsReportGetFullReport)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchleadsReportGetOrganizationList), fork(watchleadsReportGetFullReport)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/leads/leadsReportSaga.js